import React from "react";

export const LookupContext = React.createContext({
  lookups:[]
});

